@layer module {
.calendar-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.calendar-header__arrow {
            display: grid;
            place-items: center;
            flex-shrink: 0;
            border: none;
            cursor: pointer;
    }

.calendar-header__arrow:disabled {
            cursor: default;
    }

.calendar-header__selects {
            display: flex;
            align-items: center;
    }

.calendar-header__button {
            display: inline-flex;
            align-items: center;
            border: 1px solid;
            cursor: pointer;
    }

.calendar-header__panel {
            position: absolute;
            inset: 0;
            z-index: 2;
            display: flex;
            flex-direction: column;
    }

.calendar-header__panel-bar {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.calendar-header__close {
            display: grid;
            place-items: center;
            border: none;
            cursor: pointer;
    }

.calendar-header__list {
            position: relative;
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            align-content: start;
            flex: 1 1 auto;
            min-height: 0;
            overflow-y: auto;
    }

.calendar-header__option {
            border: none;
            text-align: center;
            cursor: pointer;
    }

.calendar-header__option:disabled {
            cursor: default;
    }
} // layer module










@layer app {
.calendar-header {
            gap: $size-8;
            margin: $size-10;
    }

.calendar-header__arrow {
            width: $size-30;
            height: $size-30;
            padding: 0;
            border-radius: 50%;
    }

.calendar-header__selects {
            gap: $size-8;
    }

.calendar-header__button {
            gap: $size-6;
            padding: $size-4 $size-8;
            border-radius: $size-8;
    }

.calendar-header__panel-bar {
            padding: $size-10 $size-12 $size-6 $size-16;
    }

.calendar-header__close {
            width: $size-30;
            height: $size-30;
            padding: 0;
            border-radius: 50%;
    }

.calendar-header__list {
            gap: $size-4;
            padding: 0 $size-10 $size-10;
    }

.calendar-header__option {
            height: $size-34;
            padding: 0 $size-4;
            border-radius: $size-17;
    }

.calendar-header__arrow {
            background: transparent;
            color: var(--text-primary);
            font-size: var(--font-size-lg);
    }

.calendar-header__arrow:hover:where(:not(:disabled)) {
            background: var(--rdp-day-hover-bg);
    }

.calendar-header__arrow:disabled {
            color: var(--rdp-day-disabled-text);
    }

.calendar-header__button {
            background: var(--bg-surface);
            border-color: var(--border-default);
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            text-transform: capitalize;
    }

.calendar-header__button[aria-expanded='true'] {
            border-color: var(--rdp-day-selected-bg);
    }

.calendar-header__panel {
            background: var(--bg-surface);
            color: var(--text-primary);
    }

.calendar-header__panel-bar {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }

.calendar-header__close {
            background: transparent;
            color: var(--text-secondary);
            font-size: var(--font-size-lg);
    }

.calendar-header__close:hover {
            background: var(--rdp-day-hover-bg);
    }

.calendar-header__option {
            background: transparent;
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            text-transform: capitalize;
    }

.calendar-header__option:hover:where(:not(:disabled)) {
            background: var(--rdp-day-hover-bg);
    }

.calendar-header__option[aria-selected='true'] {
            background: var(--rdp-day-selected-bg);
            color: var(--rdp-day-selected-text);
    }

.calendar-header__option[aria-selected='true']:hover {
            background: var(--rdp-day-selected-hover-bg);
            color: var(--rdp-day-selected-hover-text);
    }

.calendar-header__option:disabled {
            color: var(--rdp-day-disabled-text);
    }

.calendar-header__arrow:focus-visible,
.calendar-header__button:focus-visible,
.calendar-header__close:focus-visible,
.calendar-header__option:focus-visible {
            outline: 2px solid var(--color-brand-ring);
            outline-offset: 1px;
    }
} // layer app
